module.exports = __webpack_public_path__ + "images/application/wiggles-69468939.svg";